import { useState, useEffect } from "react";
import { StorageKeys } from "@/common/constants/storageKeys";

export const useTeamsTheme = () => {
    const [theme, setTheme] = useState(() => 
        localStorage.getItem(StorageKeys.TeamsTheme) || "default"
    );

    useEffect(() => {
        const handleStorageChange = (e: StorageEvent) => {
            if (e.key === StorageKeys.TeamsTheme) {
                setTheme(e.newValue || "default");
            }
        };

        // Listen for storage changes from other tabs/windows
        window.addEventListener("storage", handleStorageChange);

        // Custom event for same-window changes
        const handleCustomEvent = (e: CustomEvent) => {
            setTheme(e.detail);
        };

        window.addEventListener("teamsThemeChanged" as any, handleCustomEvent);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
            window.removeEventListener("teamsThemeChanged" as any, handleCustomEvent);
        };
    }, []);

    return theme;
};